import React, {useEffect} from 'react';
import {Box, Button, Dialog} from '@mui/material';
import {CloseButton, ExternalLinks, InfoContainer, InfoContent, InfoTitle} from './style';
import CloseIcon from '@mui/icons-material/Close';
import CredorNotFound from 'images/credor-not-found.svg';
import {useParams} from 'react-router-dom';
import {useTracking} from 'contexts/tracking';
import {AcaoEvento} from 'services/TrackingService';
import {SituacaoCredor} from "../../pages/Login";

interface ICredorNotFoundDialogProps {
  open: boolean;
  onClose: () => void;
  financeira?: string;
  buscarCpfCnpjSemFormatacao?: () => string;
  situacao: SituacaoCredor;
}

const CredorNotFoundDialog = ({ open, onClose, financeira, buscarCpfCnpjSemFormatacao, situacao }: ICredorNotFoundDialogProps) => {
  const { trackId } = useParams<{ trackId: string | undefined }>()
  const { sendTracking } = useTracking();

  useEffect(() => {
    if (open) {
      const cpfCnpj = buscarCpfCnpjSemFormatacao ? buscarCpfCnpjSemFormatacao() : "";
      sendTracking({ trackId, acao: situacao === SituacaoCredor.DadosNaoEncontrado ? AcaoEvento.DadosNaoLocalizados : AcaoEvento.ClienteNaoEncontrado, cpfCnpj });
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      maxWidth={'xs'}
      onClose={onClose}
    >
      <CloseButton onClick={onClose}>
        <CloseIcon color="primary" />
      </CloseButton>
      <InfoContainer>
        <Box>
          <img src={CredorNotFound} alt="Cpf/Cnpj não encontrado" />
        </Box>
        <InfoTitle>
          Desculpe, não localizamos <br />seus dados.
        </InfoTitle>
        {financeira === 'bradesco' && (
          <>
            <InfoContent>
              Por favor, acesse os canais digitais do Bradesco: Fone Fácil, Internet Banking, Autoatendimento e App Bradesco.
            </InfoContent>
            <InfoContent>
              <b>Portal Bradesco:</b>
              <br />
              <ExternalLinks href='https://bradesco.negociedigital.com.br' target='_blank'>
                https://bradesco.negociedigital.com.br
              </ExternalLinks>
              <br />
              <b>Portal Bradesco Cartões:</b>
              <br />
              <ExternalLinks href='https://bradescard.rcbserv.com.br/Home' target='_blank'>
                https://bradescard.rcbserv.com.br/Home
              </ExternalLinks>
            </InfoContent>
            <InfoContent>
              Se não tiver acesso, procure seu gerente ou Agência Bradesco mais próxima.
            </InfoContent>
          </>
        )}
        <Button
          size="large"
          style={{ height: 45, width: 150 }}
          variant="contained"
          color="primary"
          onClick={onClose}
        >
          Entendi
        </Button>
      </InfoContainer>
    </Dialog>
  );
}

export default CredorNotFoundDialog;
